/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_No_StepsInputs */

const en_cook_no_steps = /** @type {(inputs: Cook_No_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This recipe has no steps. Tick off the ingredients as you go.`)
};

const de_cook_no_steps = /** @type {(inputs: Cook_No_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Rezept hat keine Schritte. Hak die Zutaten beim Kochen ab.`)
};

/**
* | output |
* | --- |
* | "This recipe has no steps. Tick off the ingredients as you go." |
*
* @param {Cook_No_StepsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_no_steps = /** @type {((inputs?: Cook_No_StepsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_No_StepsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_no_steps(inputs)
	return en_cook_no_steps(inputs)
});